<template>
  <div>
    <div class="flex flex-row h-full">
      <div id="product_facets"
           :class="{'w-1/2 lg:w-2/5 1.5xl:w-1/4 4k:w-1/5': opened, 'w-1/30':!opened}">
        <c-product-facets
          v-if="facetsLoaded"
          @reload-facets="resetFacets"
          class="overflow-y-auto h-full"
          :opened.sync="opened"
          :facets="facets"
          :queryData="queryObject"
          :onlyNew.sync="onlyNew"
        />
      </div>
      <div id="products" class="h-full"
           :class="{'w-1/2 lg:w-3/5 1.5xl:w-3/4 pl-10 pr-10 1.5xl:pl-10 1.5xl:pr-20 4k:w-4/5': opened, 'w-29/30 px-2':!opened}">
        <div
          class="flex flex-row justify-between w-full gap-1 h-3/20 lg:h-1/20 mb-1 mr-4 items-center mb-5">
          <div class="flex flex-row gap-2">
            <c-selection-picker
              v-if="displayQuick && hasPermissionToSeeQuickSelections()"
              class="col-span-2 1.5xl:col-span-1 selection"
              :selected.sync="selectedSelection"
              :all-selected="allAdded"
              @addSearchProductsToSelection="addSearchProductsToSelection">
            </c-selection-picker>
            <div class="col-span-1 flex items-center"
                 v-if="hasPermissionToSeeQuickSelections()">
              <div @click="displayQuick=!displayQuick" class="cursor-pointer displayQuick">
                <div v-if="displayQuick" class="displayQuick bg-classen__primary">
                  <label><i class="fas fa-eye"></i></label>
                </div>
                <div v-if="!displayQuick" class="displayQuick bg-classen__primary">
                  <label><i class="fas fa-eye-slash"></i></label>
                </div>
              </div>
              <p v-if="!displayQuick" class="ml-2 font-bold"> Show quickselections </p>
            </div>
          </div>
          <c-sort :title="getTranslation('sortBy')" @updateSelected="updateSort"
                  :items="filters"
                  class="order_by"></c-sort>
        </div>
        <products-display
          v-if="isLoaded"
          class="overflow-y-auto h-18/20 pb-5"
          :filter-open="opened"
          :products="filteredProducts"
          :hasMore="links.next !== null && meta.total !== 0 && filteredProducts.length !== 0"
          :selectedSelection="selectedSelection"
          @load-more="fetchNextProducts"
          :displayQuick="!!(displayQuick && hasPermissionToSeeQuickSelections())"
        />
        <div class="flex align-middle h-17/20" v-else>
          <c-loader :inline="true"/>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import debounce from "debounce";
import ProductFacets from "./ProductFacets";
import ProductsDisplay from "./ProductsDisplay";
import SortingDropdown from "../SortingDropdown";
import getTranslation from "../../../mixins/getTranslation";
import EventBus from "../../../services/EventBus";
import SelectionPicker from "../SelectionPicker";
import getPermissions from "../../../mixins/getPermissions";
import Loader from "../../Loader";

export default {
  name: 'Products',

  mixins: [getTranslation, getPermissions],

  data() {
    return {
      page: 1,
      size: 48,
      products: [],
      meta: [],
      allAdded: false,
      links: [],
      displayQuick: true,
      facets: {},
      articleName: 'test',
      opened: true,
      facetsLoaded: true,
      onlyNew: false,
      isLoaded: false,
      isFetching: false,
      selectedSelection: {id: -1, name: "Set default selection"},
      queryObject: {
        query: {
          articleName: "",
          articleNumber: null,
          rangeName: "",
          decorName: "",
          decorNumber: "",
          length: null,
          width: null,
          height: null,
          boxId: null,
          inlayId: null,
          brands: [],
          categories: [],
          productGroups: [],
          wearclass: [],
          bevels: [],
          structures: [],
          status: 'Active'
        },
        sort: {articleNumber: {order: 'desc'}},
        language: "en"
      },
    }
  },

  components: {
    ProductsDisplay,
    'c-product-facets': ProductFacets,
    'c-product-display': ProductsDisplay,
    'c-sort': SortingDropdown,
    'c-selection-picker': SelectionPicker,
    'c-loader': Loader,
  },

  created() {
    this.fetchFacets();
    this.fetchProducts();
    this.loadSelections();
    EventBus.listen('update-status', this.setStatus);
    EventBus.listen('add-to-global-selection', this.addToSelection);
    EventBus.listen('remove-from-global-selection', this.addToSelection);
    EventBus.listen('clear-selected-selection', this.clearSelection);
  },

  destroyed() {
    EventBus.destroy('update-status', this.setStatus);
    EventBus.destroy('add-to-global-selection', this.addToSelection);
    EventBus.destroy('add-to-global-selection', this.addToSelection);
    EventBus.destroy('clear-selected-selection', this.clearSelection);
  },

  computed: {
    filters() {
      return [
        {value: 'externalId', direction: 'desc', text: this.getTranslation('newToOld')},
        {value: 'articleName', direction: 'asc', text: this.getTranslation('name')},
        {value: 'articleNumber', direction: 'desc', text: this.getTranslation('articleNumber')},
        {value: 'range', direction: 'asc', text: this.getTranslation('range')},
        {value: 'categoryName', direction: 'asc', text: this.getTranslation('category')},
      ];
    },

    filteredProducts() {
      if (this.onlyNew) {
        return this.products.filter((product) => product.isNew);
      }
      return this.products;
    },

    selectedBrands() {
      if (!this.facets.brands) {
        return []
      }

      const brands = this.facets.brands.filter((item) => {
        return item.selected;
      });

      this.queryObject.query.brands = brands.map((brand) => brand.name);
      return brands
    },

    selectedCategories() {
      if (!this.facets.categories) {
        return []
      }

      const categories = this.facets.categories.filter((item) => {
        return item.selected;
      });

      this.queryObject.query.categories = categories.map((category) => category.name);
      return categories
    },

    selectedBevels() {
      if (!this.facets.bevels) {
        return []
      }

      const bevels = this.facets.bevels.filter((item) => {
        return item.selected;
      });

      this.queryObject.query.bevels = bevels.map((bevel) => bevel.name);
      return bevels;
    },

    selectedProductGroups() {
      if (!this.facets.productGroups) {
        return []
      }

      const productGroups = this.facets.productGroups.filter((item) => {
        return item.selected;
      });

      this.queryObject.query.productGroups = productGroups.map((productGroup) => productGroup.name);
      return productGroups;
    },

    selectedRanges() {
      if (!this.facets.ranges) {
        return []
      }

      return this.facets.ranges.filter((item) => {
        return item.selected;
      });
    },

    selectedStructures() {
      if (!this.facets.structures) {
        return []
      }

      const structures = this.facets.structures.filter((item) => {
        return item.selected;
      })

      this.queryObject.query.structures = structures.map((structure) => structure.name)
      return structures;
    },

    selectedWearClasses() {
      if (!this.facets.wearclasses) {
        return []
      }

      const wearClasses = this.facets.wearclasses.filter((item) => {
        return item.selected;
      });

      this.queryObject.query.wearclass = wearClasses.map((wearClass) => wearClass.name);
      return wearClasses;
    },

  },

  watch: {
    selectedSelection() {
      this.allAdded = false;
      this.$emit('selectionChanged', this.selectedSelection)
    },

    selectedBrands() {
      if (this.selectedBrands.length === 0 && !this.isLoaded) {
        return;
      }

      this.fetchProducts();
    },

    selectedCategories() {
      if (this.selectedCategories.length === 0 && !this.isLoaded) {
        return;
      }

      this.fetchProducts();
    },

    selectedBevels() {
      if (this.selectedBevels.length === 0 && !this.isLoaded) {
        return;
      }

      this.fetchProducts();
    },

    selectedProductGroups() {
      if (this.selectedProductGroups.length === 0 && !this.isLoaded) {
        return;
      }

      this.fetchProducts();
    },

    selectedWearClasses() {
      if (this.selectedWearClasses.length === 0 && !this.isLoaded) {
        return;
      }

      this.fetchProducts();
    },

    selectedStructures() {
      if (this.selectedStructures.length === 0 && !this.isLoaded) {
        return;
      }

      this.fetchProducts();
    },

    "queryObject.query.articleName": debounce(function () {
      this.fetchProducts()
    }, 500),

    "queryObject.query.articleNumber": debounce(function () {
      this.fetchProducts()
    }, 500),

    "queryObject.query.rangeName": debounce(function () {
      this.fetchProducts()
    }, 500),

    "queryObject.query.length": debounce(function () {
      this.fetchProducts()
    }, 500),

    "queryObject.query.width": debounce(function () {
      this.fetchProducts()
    }, 500),

    "queryObject.query.height": debounce(function () {
      this.fetchProducts()
    }, 500),

    "queryObject.query.decorName": debounce(function () {
      this.fetchProducts()
    }, 500),

    "queryObject.query.boxId": debounce(function () {
      this.fetchProducts()
    }, 500),

    "queryObject.query.inlayId": debounce(function () {
      this.fetchProducts()
    }, 500),

    "queryObject.sort": debounce(function () {
      this.fetchProducts()
    }, 500),
  },

  methods: {
    clearSelection() {
      this.allAdded = false
    },

    setStatus(status) {
      this.queryObject.query.status = status;
      this.fetchProducts();
    },

    loadSelections() {
      this.$dashboardStore.dispatch('getSelections');
      this.$dashboardStore.dispatch('getSelectionSuggestions');
    },

    updateSort(val) {
      this.queryObject.sort = {};
      this.queryObject.sort[val.value] = {order: val.direction}
    },

    async fetchProducts() {
      if (this.isFetching) {
        return
      }
      this.isFetching = true;
      this.isLoaded = false;

      this.page = 1;
      const data = {page: this.page, size: this.size, queryData: this.queryObject}
      const response = await this.$dashboardStore.dispatch('searchProducts', data)
      this.products = response.data;
      this.meta = response.meta;
      this.links = response.links;
      this.rerenderDisplay();

      this.isFetching = false;
      this.isLoaded = true;
      this.$dashboardStore.dispatch('getSelections');
    },

    addSearchProductsToSelection() {
      if (this.selectedSelection.id === -1) {
        return;
      }

      let data = this.queryObject;
      data.selectionId = this.selectedSelection.id

      EventBus.fire('showLoader');
      if (this.allAdded) {
        this.$dashboardStore.dispatch('removeSearchProductsFromSelection', data)
          .then(() => {
            this.products.forEach((product) => {
              product.selections = product.selections.filter((selectionItem) => {
                return selectionItem.id !== this.selectedSelection.id;
              });
            })
            this.allAdded = false;
            EventBus.fire('hideLoader');
          })
          .catch((error) => {
            console.warn('something went wrong adding all', error);
            EventBus.fire('hideLoader');
          });
        return;
      }

      this.$dashboardStore.dispatch('addSearchProductsToSelection', data)
        .then(() => {
          this.products.forEach((product) => {
            product.selections.push(this.selectedSelection);
          })
          this.allAdded = true;
          EventBus.fire('hideLoader');
        })
        .catch((error) => {
          console.warn('something went wrong adding all', error);
          EventBus.fire('hideLoader');
        });
    },

    fetchNextProducts() {
      this.page++;
      const data = {page: this.page, size: this.size, queryData: this.queryObject}
      this.$dashboardStore.dispatch('searchProducts', data)
        .then((response) => {
          this.products = [...this.products, ...response.data];
          this.meta = response.meta;
          this.links = response.links;
        });
    },

    resetFacets() {
      this.$emit('resetFilters');
      this.$set(this, 'onlyNew', false);
      this.queryObject.query = {
        articleName: "",
        articleNumber: null,
        rangeName: "",
        decorName: "",
        decorNumber: "",
        length: null,
        width: null,
        height: null,
        boxId: null,
        inlayId: null,
        brands: [],
        categories: [],
        productGroups: [],
        wearclass: [],
        bevels: [],
        structures: [],
        status: null
      }

      this.facetsLoaded = false;
      this.$nextTick(() => {
        this.facetsLoaded = true
        this.fetchFacets();
      })
    },

    fetchFacets() {
      this.$dashboardStore.dispatch('getProductsFacets')
        .then((response) => {
          this.facets = response.data;
        });
    },

    rerenderDisplay() {
      this.isLoaded = false;
      this.$nextTick(() => {
        this.isLoaded = true;
      });
    },
  }
}
</script>
<style scoped>
.displayQuick {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  line-height: 40px;
  color: white;
}

.selection {
  width: 250px;
}

.order_by {
  width: 250px;
}
</style>
